import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';


export interface UserSettingsState {
    playerdisplay: "card"|"table";
    snackbaropen: boolean;
    snackbarmessage: string;
    magicnumber: number;
    themeMode: "light"|"dark";
}

export interface payload {
    magicnumber: number;
}

const initialState: UserSettingsState = {
    playerdisplay: "table",
    snackbaropen: false,
    snackbarmessage: '',
    magicnumber: 0,
    themeMode: "light"
}


export const selectPlayerDisplay = (state: RootState) => state.user.playerdisplay;

export const selectSnackbarOpen = (state: RootState) => {
    return state.user.snackbaropen
};

export const selectSnackbarMessage = (state: RootState) => state.user.snackbarmessage;

export const selectMagicNumber = (state: RootState) => state.user.magicnumber;

export const selectThemeMode = (state: RootState) => state.user.themeMode;

export const UserSettingsSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        ChangeMagicNumber: (state, action: PayloadAction<number>) => {
            console.log("CMN: ", action);
            state.magicnumber = action.payload;
        },
        TogglePlayerDisplay: (state, action: PayloadAction<string>) => {
            if (action.payload === 'card') {
                state.playerdisplay = 'card';
            } else {
                state.playerdisplay = 'table';
            }
        },
        SetSnackBarOpen:(state,action: PayloadAction<boolean>) => {
            state.snackbaropen = action.payload;
        },
        SetSnackBarText: (state,action: PayloadAction<string>) => {
            state.snackbarmessage = action.payload;
        },
        ToggleThemeMode: (state) => {
            if (state.themeMode == 'light') {
                state.themeMode = 'dark';
            } else {
                state.themeMode = 'light';
            }
        }
    },
    // extraReducers: (builder) => {
        
    //     builder
    // }
});



export const { ChangeMagicNumber, TogglePlayerDisplay, SetSnackBarOpen, SetSnackBarText, ToggleThemeMode } = UserSettingsSlice.actions;

export default UserSettingsSlice.reducer;
